import axios from 'axios'
import notifications from '@/libs/notifications'

export default function setup (store) {
  function unauthorizedResponseHandler () {
    // notify
    // this.$store.dispatch('logout')
    return true
  }
  function errorResponseHandler (response) {
    if (response.status) {
      var statusCategory = parseInt(response.status.toString().charAt(0))
      if (statusCategory === 5) {
        console.error('Internal server error')
        notifications.error('El servidor reportó un error desconocido')
        if (response.status === 503) {
          console.log('Servicio temporalmente no disponible')
        } else if (response.status === 500) {
          console.log('Error 500 al procesar la petición')
        } else {
          console.log('Error al procesar la petición')
        }
      // response?.status === 401 es7 way.
      } else if (statusCategory === 4) {
        if (response.status === 400) {
          if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
            for (let i = 0; i < response.data.errors.length; i++) {
              notifications.error(response.data.errors[i].msg)
            }
          } else {
            notifications.error(response.error || response.data.error || response.data.message)
          }
          console.error(response.error || response.data.error || response.data.message)
        }
        if (response.status === 401) unauthorizedResponseHandler()
        if (response.status === 404) console.error('La ruta no existe')
      } else {
        console.log(response)
      }
    } else {
      console.log(response)
    }
    return true
  }
  axios.interceptors.request.use(function (config) {
    if (config.headers && config.headers.Authorization) return config
    const token = store.getters.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }, function (err) {
    return Promise.reject(err)
  })
  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response
  }, function (error) {
    if (process.env.VUE_APP_NODE_ENV === 'production') console.error(error)
    try {
      const { response } = error
      if (response) {
        errorResponseHandler(response)
      } else if (axios.isCancel(error)) {
        return true
      }
    } catch (err) {
      console.err(err)
    }
    return Promise.reject(error)
  })
}
